import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import "./part-service.css";
import { Trans, useTranslation } from "react-i18next";
import { HelpModalPopup } from "@components/home-page/shared-components/modal-popup/help-modal-popup";
import { HpLogo } from "@components/home-page/shared-components/hp-logo/hp-logo";
interface CasePartServiceProps {
  PartsOrdersEmptyTxt?: string;
  lstServiceOrder?: any;
  OnsiteServiceEmptyTxt?: string;
  lstPartAndOrder?: any;
}

const PartService: React.FC<CasePartServiceProps> = ({
  lstPartAndOrder,
  PartsOrdersEmptyTxt,
  lstServiceOrder,
  OnsiteServiceEmptyTxt,
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
    function handleCallBack() {
      setOpen(true);
    }
    const popupHeader = () => {
      return (
        <p className="popup-header">
          <HpLogo></HpLogo>
          <span className="ml-2">
            {t("HPI.EditCase.partsConHead.Tracking", {
              defaultValue: "Tracking",
            })}
          </span>{" "}
        </p>
      );
    };
  return (
    <div className="case-part-service">
      <Container className="container-custom">
        <Col md={12} className="container-row">
          <Row>
            <Col md={12}>
              <h5 className="">
                {t("HPI.EditCase.Partsandservice.Partsorders", {
                  defaultValue: "Order Summary:",
                })}
              </h5>
            </Col>
            {lstPartAndOrder !== null ? (
              <>
                <Row>
                  <Col>
                    {t("HPI.EditCase.Partsandservice.Subcase-ID", {
                      defaultValue: "WO Number:",
                    })}
                  </Col>
                  <Col>{lstPartAndOrder[0]?.SubCaseId}</Col>
                </Row>
                <Row>
                  <Col>
                    {t("HPI.EditCase.Partsandservice.OrderNumber", {
                      defaultValue: "Order Number:",
                    })}
                  </Col>
                  <Col>{lstPartAndOrder[0]?.CaseName}</Col>
                </Row>
                <Row>
                  <Col>
                    {t("HPI.EditCase.Partsandservice.Partnumber", {
                      defaultValue: "Part number:",
                    })}
                  </Col>
                  <Col>{lstPartAndOrder[0]?.PartNumber}</Col>
                </Row>
                <Row>
                  <Col>
                    {t("HPI.EditCase.Partsandservice.Partdescription", {
                      defaultValue: "Part description:",
                    })}
                  </Col>
                  <Col>{lstPartAndOrder[0]?.PartDescription}</Col>
                </Row>
                <Row>
                  <Col>
                    {t("HPI.EditCase.Partsandservice.Orderstatus", {
                      defaultValue: "Order status:",
                    })}
                  </Col>
                  <Col>{lstPartAndOrder[0]?.OrderStatus}</Col>
                </Row>
                <Row>
                  <Col>
                    {t("HPI.EditCase.Partsandservice.ExpectedDelieveryDate", {
                      defaultValue: "Expected Delievery Date:",
                    })}
                  </Col>
                  <Col>{lstPartAndOrder[0]?.ExpectedDeliveryDate}</Col>
                </Row>

                <Row>
                  <Col>
                    {t("HPI.EditCase.Partsandservice.PartDeliveredDate", {
                      defaultValue: "Part Delivered Date:",
                    })}
                  </Col>
                  <Col>{lstPartAndOrder[0]?.PartDeliveredDate}</Col>
                </Row>
                <Row>
                  <Col>
                    {t("HPI.EditCase.Partsandservice.Carrier", {
                      defaultValue: "Carrier:",
                    })}
                  </Col>
                  <Col>{lstPartAndOrder[0]?.Carrier}</Col>
                </Row>
                <Row>
                  <Col>
                    {t("HPI.EditCase.Partsandservice.Trackingnumber", {
                      defaultValue: "Tracking number:",
                    })}
                  </Col>
                  <Col>{lstPartAndOrder[0]?.TrackingNumber}</Col>
                </Row>
                <Row>
                  <Col>
                    {t("HPI.EditCase.Partsandservice.TrackingURL", {
                      defaultValue: "Tracking URL:",
                    })}
                  </Col>
                  <Col>{lstPartAndOrder[0]?.TrackingUrl}</Col>
                </Row>
              </>
            ) : (
              <Row>
                <Col>{PartsOrdersEmptyTxt}</Col>
              </Row>
            )}
          </Row>
          <Row>
            <Col md={12}>
              <h5>
                {t("HPI.EditCase.partsConHead.Onsiteservice", {
                  defaultValue: "Onsite Service:",
                })}
              </h5>
            </Col>
            <Col>{OnsiteServiceEmptyTxt}</Col>
          </Row>
          <Row>
            {lstServiceOrder?.map((val: any, index: number) => (
              <>
                <Row>
                  <Col md={3}>
                    <h5>
                      {t("HPI.EditCase.partsConHead.Subcase-ID", {
                        defaultValue: "Subcase-ID:",
                      })}
                    </h5>
                  </Col>
                  <Col md={6}>{val.SubCaseId}</Col>
                </Row>

                <Row>
                  <Col md={3}>
                    <h5>
                      {t("HPI.EditCase.partsConHead.ServiceOrderID", {
                        defaultValue: "Service Order ID:",
                      })}
                    </h5>
                  </Col>
                  <Col md={6}>{val.CaseTitle}</Col>
                </Row>

                <Row>
                  <Col md={3}>
                    <h5>
                      {t("HPI.EditCase.partsConHead.Servicestatus", {
                        defaultValue: "Service status:",
                      })}
                    </h5>
                  </Col>
                  <Col md={6}>{val.ServiceStatus}</Col>
                </Row>

                <Row>
                  <Col md={3}>
                    <h5>
                      {t("HPI.EditCase.partsConHead.ServiceOrderStatus", {
                        defaultValue: "Service Order Status:",
                      })}
                    </h5>
                  </Col>
                  <Col md={6}>{val.OrderStatus}</Col>
                </Row>
                <Row>
                  <Col md={3}>
                    <h5>
                      {t("HPI.EditCase.partsConHead.OrderReferenceID", {
                        defaultValue: "Order Reference ID (CSO Number):",
                      })}
                    </h5>
                  </Col>
                  <Col md={6}>{val.OrderReferenceId}</Col>
                </Row>
                <Row>
                  <Col md={3}>
                    <h5 className="d-inline-block">
                      {t("HPI.EditCase.partsConHead.Tracking", {
                        defaultValue: "Tracking",
                      })}{":"}
                    </h5>
                    <HelpModalPopup
                      align={"start"}
                      id={"modal-popup"}
                      show={open}
                      onClose={() => setOpen(false)}
                      title={popupHeader()}
                      callback={handleCallBack}
                    >
                      <p>{t("HPI.EditCase.partsConHead.Tracking.tooltiptext", {defaultValue: "Track the status of your service order through this link. Keep your order reference number and serial number handy"})} </p>
                    </HelpModalPopup>
                  </Col>
                  <Col md={6}><a href="https://www.hp.com/go/csostatus" target="_blank">{t("HPI.EditCase.Case.ClickHere", {defaultValue: "Click Here"})}</a></Col>
                </Row>
                <Row>
                  <Col md={3}>
                    <h5>
                      {t("HPI.EditCase.partsConHead.Expectedservicedate", {
                        defaultValue: "Expected service date:",
                      })}
                    </h5>
                  </Col>
                  <Col md={6}>{val.ExpectedServiceDate}</Col>
                </Row>
                <Row>
                  <Col md={3}>
                    <h5>
                      {t("HPI.EditCase.partsConHead.CompletedServiceDate", {
                        defaultValue: "Completed service date:",
                      })}
                    </h5>
                  </Col>
                  <Col md={6}>{val.CompletedServiceDate}</Col>
                </Row>
              </>
            ))}
          </Row>
        </Col>
      </Container>
    </div>
  );
};

export default PartService;
